import { defineMessages } from 'react-intl';

export const errorMessages = defineMessages({
  scExceededItemCountMessage: {
    id: 'checkout.cartPage.product.exceededCountMessage',
    defaultMessage:
      'We are very sorry, but the product {productName} {annotation} we have only {quantity} pcs in stock, so this quantity was added to your cart.',
    description: 'Product count exceeded error msg',
  },
  scExceededItemCountHeader: {
    id: 'checkout.cartPage.product.exceededCountHeader',
    defaultMessage: 'We have only {quantity} pieces in stock',
    description: 'Product count exceeded error msg header',
  },
});
